export default "__VITE_ASSET__I$bAw2l___"